<template>
  <component
    :is="currentComponent"
    :open="open"
    class="h-full"
    @redirect-to-login="redirectToLogin()"
    @change-view="handleChangeView"
  />
</template>

<script setup lang="ts">
import AuthStart from "./AuthStart.vue";
import AuthCode from "./AuthCode.vue";
import AuthAccept from "./AuthAccept.vue";
import AuthData from "./AuthData.vue";
import { useRoute } from "vue-router";
import AuthLogin from "./AuthLogin.vue";

type ModalView = "start" | "code" | "accept" | "data";
const route = useRoute();

const props = defineProps({
  open: Boolean,
  view: {
    type: String as () => ModalView,
    default: "start",
  },
});

const modalView = ref<ModalView>(props.view);
const currentComponent = computed(() => viewComponents[modalView.value]);
const viewComponents = {
  start: AuthStart,
  code: AuthCode,
  accept: AuthAccept,
  data: AuthData,
  login: AuthLogin,
};

const redirectToAuthentication = inject(
  "redirectToAuthentication"
) as (params: { clientCode?: string | string[] }) => Promise<void>;

function redirectToLogin() {
  let slug: string | undefined = route.params.slug as string | undefined;
  if (!slug) {
    const pathMatch = window.location.pathname.match(/^\/([^/]+)/);
    if (pathMatch && pathMatch[1]) {
      slug = pathMatch[1];
    }
  }
  redirectToAuthentication({
    clientCode: slug,
  });
}

function handleChangeView(view: ModalView) {
  modalView.value = view;
}
</script>
